module.exports = __webpack_public_path__ + "img/product-listing.51397d72.png";